/**
 * Connactable-Aufgabe: Abfragen einer Verbindung zwischen 2 Element
 * @namespace v3sWbtPlayerApp:exercise:connectable
 */

/**
 * Definiert die v3s-connectable Direktive <br/>
 * Die Direktive stellt ein Element dar, von dem eine Linie/Verbindung zu einem anderen Element gezogen werden kann <br/>
 * Die eigentlichen Aufgaben-Element sind die {@link v3sWbtPlayerApp:exercise:connectable.directive_v3sConnection}
 * @class directive_v3sConnectable
 * @memberOf v3sWbtPlayerApp:exercise:connectable
 * @param {id} id - id des Elements
 * @param {number} v3s-top - top Position des Elements
 * @param {number} v3s-left - left Position des Elements
 * @param {number} v3s-height - Höhe des Elements
 * @param {number} v3s-width - Breite des Elements
 * @example
 * <v3s-connectable id="CN01" v3s-left="20" v3s-top="20" v3s-width="20" v3s-height="20">
 *      <v3s-description></v3s-description>
 *      <v3s-data></v3s-data>
 *      <v3s-fod></v3s-fod>
 * </v3s-connectable>
 */
angular.module('v3sWbtPlayerApp').directive('v3sConnectable', ['$tooltip', 'v3sGeometricsService', '$compile', 'v3sConnectableElement', '$document', 'v3sGsapService', function ($tooltip, v3sGeometricsService, $compile, v3sConnectableElement, $document, v3sGsapService) {
    return {
        restrict: 'E',
        require : ['^v3sDocument','^v3sExercise'],
        scope : {
            id : '@',
            v3sTop : '@',
            v3sLeft : '@',
            v3sHeight: '@',
            v3sWidth: '@'
        },
        link: function (scope, element, attrs, controllers) {
            var v3sDocumentCtrl = controllers[0];
            var v3sExerciseCtrl = controllers[1];

            scope.getvar = v3sDocumentCtrl.getVar;

            //Solange der Darstellungstyp "block/inlineblock" ist,
            //muss die Größe des Connectables auf das data-element durchschlagen
            //-> else block
            var v3sData = element.find("v3s-data");

            //Wenn die höhe und Breite 0 ist, soll die
            //Größe sich an den Text anpassen.
            if (attrs.v3sWidth == "0") {
                element.css("width", "");
            } else {
                v3sData.css("width", attrs.v3sWidth + "px");
            }
            if (attrs.v3sHeight == "0") {
                element.css("height", "");
            } else {
                v3sData.css("height", attrs.v3sHeight + "px");
            }

            //Das Element im ExerciseController "anmelden"
            v3sExerciseCtrl.addConnectable(element);

            //Beim FOD dieses Elementes gibt es keinen Status
            var tooltip, fod, dragEl;
            var dragWidth = scope.v3sWidth;
            var dragHeight = scope.v3sHeight;
            fod = element.find('v3s-fod').remove();



            //Startcoords der Line
            var lineStartX, lineStartY;
            //Die Targets für den Hittest des Draggable Elements ('v3s-connectable')
            var targets = v3sExerciseCtrl.getConnectables();


            //Hilfsvariablen
            var shrank = false;
            var foundTarget = null;

            //Das Element, dass das Zeichnen der Connection anzeigt
            var dragLine = angular.element('<v3s-line class="line"></v3s-line>');



            $document.ready(function () {
                //Wenn wir in der Auswertungsansicht im Test sind, brauchen wir kein Draggable...
                if (connectableElement.completed) return;
                //Wenn die Höhe und die Breite im WBTD automatisch gesetzt wurde,
                //müssen sie jetzt berechnet werden
                if (dragHeight == 0) {
                    dragHeight = element[0].offsetHeight;
                    element.attr('v3s-height', dragHeight);
                }
                if (dragWidth == 0) {
                    dragWidth = element[0].offsetWidth;
                    element.attr('v3s-width', dragWidth);
                }
                //Das compilierte Element, dass das DragNDrop initieren soll
                dragEl = angular.element('<v3s-draggable id="' + scope.id + '-drag" v3s-left="{{v3sLeft}}" v3s-top="{{v3sTop}}" v3s-width="' + dragWidth + '" v3s-height="' + dragHeight + '"></v3s-draggable>');

                $compile(dragEl)(scope);

                v3sDocumentCtrl.addElement(dragEl);


                //Elemente an die ExerciseDirektive hängen
                v3sExerciseCtrl.appendElement(dragLine);
                v3sExerciseCtrl.appendElement(dragEl);

                //Das Draggable-Element mit allen Funktionen und Event-Handlern
                var draggable = v3sGsapService.createDraggable(dragEl, {
                    type : "top,left",
                    onPress: onPress,
                    onDrag: onDrag,
                    onRelease: onRelease,
                    cursor : 'pointer'
                });
            });

            //Exercise Element erstellen;
            var connectableElement = new v3sConnectableElement(scope.id);
            var showFeedback = function () {
                if (this.completed && this.isFeedbackVisible()) {
                    /**
                     * dragEl wird entfernt, da es im Test beim aufruf der Korrekturansicht
                     * nicht definiert ist und somit zu fehler führt
                     */

                    var deleteThisDragEl = document.querySelector("#" + scope.id + "-drag");
                    if (!!deleteThisDragEl) angular.element(deleteThisDragEl).remove();
                    var tooltip = $tooltip(element, { title: fod.html()});
                }
            }
            connectableElement.setShowFeedback(showFeedback);



            /*******************************************************************
             *
             * Eventhandler des Draggable-Elements und ihre Helferfunktionen
             *
             *******************************************************************/

            /*
             * onPress handler
             * Verkleinert das Draggable-Element auf die größe 40x40
             * Zentriert den Pointer in der Mitte des Draggable-Elements
             */
            function onPress(evt) {
                if (connectableElement.completed) this.disable();
                //testen ob es evt.offsetX etc gibt
                if (!!evt.offsetX) {
                    lineStartY = parseInt(attrs.v3sTop) + evt.offsetY;
                    lineStartX = parseInt(attrs.v3sLeft) + evt.offsetX;
                } else {//TOUCH
                    if (!!evt.touches[0]) {
                        lineStartY = parseInt(attrs.v3sTop) + (evt.touches[0].pageY - v3sGeometricsService.getOffset(element).top);
                        lineStartX = parseInt(attrs.v3sLeft) + (evt.touches[0].pageX - v3sGeometricsService.getOffset(element).left);
                    }
                }
                TweenLite.set(dragLine, {
                    top: lineStartY,
                    left: lineStartX
                });
                var x2 = (lineStartX + this.x);
                var y2 = (lineStartY + this.y);
                var w = v3sGeometricsService.calculateLength(lineStartX, lineStartY, x2, y2) + "px";
                var deg = v3sGeometricsService.calculateAngle(lineStartX, lineStartY, x2, y2);
                TweenLite.set(evt.target, {
                    //rotation: deg+'_short',
                    width: w
                });

                if (shrank) return;
                var self = this;
                var x = lineStartX;
                var y = lineStartY;

                TweenLite.set(evt.target, {
                    width: 20,
                    height: 20,
                    left: x - 10 ,
                    top: y - 10
                });
                //This update, damit das Draggable von seinen neuen x,y werten weiss
                this.update();
                evt.stopPropagation();
            }

            /**
             * OnDrag handler
             * "Zeichnet" die Linie zwischen Startpunkt und Endpunkt
             */

            function onDrag(evt) {
                var x2 = this.x + 10;
                var y2 = this.y + 10;
                var w = v3sGeometricsService.calculateLength(lineStartX, lineStartY, x2, y2) + "px"
                var deg = v3sGeometricsService.calculateAngle(lineStartX, lineStartY, x2, y2);
                TweenLite.set(dragLine,{
                    rotation: deg+'_short',
                    width: w
                });
            }

            /**
             * OnRelease handler
             * 1. Prüfen, ob das Draggable element über einem gültigen Element losgelassen wurde
             * 2. Das Element auf dem Getroffendem zentrieren
             * 3. Neues ConnectionElement erstellen
             * 4. Reset von Linie und Draggable
             */

            function onRelease(evt) {
                var self = this;
                //Wurde ein Target getroffen?
                angular.forEach(targets, function (t) {
                    //Es wurde noch keins gefunden
                    if (!foundTarget) {
                        if (self.hitTest(t, "50%")) {
                            //Es wurde ein anderes Connectable getroffen
                            if (self.target.id.indexOf(t.attr('id')) === -1) {

                                var bestConnection = v3sGeometricsService.findBestConnection(element, t);
                                //Neuberechnung für die Knotepunkte
                                var deg = v3sGeometricsService.calculateAngle(bestConnection.x1, bestConnection.y1, bestConnection.x2, bestConnection.y2);
                                var w = v3sGeometricsService.calculateLength(bestConnection.x1, bestConnection.y1, bestConnection.x2, bestConnection.y2) + "px";
                                v3sExerciseCtrl.exercise.createConnection("conn_" + element.attr('id') + t.attr('id'), element.attr('id'), t.attr('id'), bestConnection.x1, bestConnection.y1, deg, parseInt(w), "updated");
                                resetDraggables();
                            }

                        } else {
                            returnDraggables();
                        }
                    }
                });
            }

            //Hard Reset Line und Draggable
            var resetDraggables = function() {
                TweenLite.set(dragEl, {
                    left : scope.v3sLeft,
                    top: scope.v3sTop,
                    width: dragWidth,
                    height: dragHeight
                });
                TweenLite.set(dragLine, {
                    clearProps : 'rotation, width'
                });
            }

            //Animierte Rückführung der Elemente
            var returnDraggables = function() {
                TweenLite.to(dragEl, 0.5, {
                    left: scope.v3sLeft,
                    top: scope.v3sTop,
                    width: dragWidth,
                    height: dragHeight
                });
                TweenLite.to(dragLine, 0.5,{
                    width:0
                });
            }
        }


    }
}]);

/**
 * Definiert Model des v3sConnectable Elements
 * Das Model ist nötig, damit das abgefragt werden kann, ob die Aufgabe completed ist und
 * somit das FOD zum richtigen Moment angezeigt werden kann
 * @class service_v3sConnectableElement
 * @memberOf v3sWbtPlayerApp:exercise:connectable
 */
angular.module('v3sWbtPlayerApp').factory('v3sConnectableElement',['v3sExerciseElement', function (v3sExerciseElement) {
    /**
     * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sHotspotElement
     * @param {string} from - ID des Startelements
     * @param {string} to - ID des Endelements
     * @param {boolean} isCorrectAnswer - zeigt an, ob es eine korrekte Antwort ist
     * @param {object} element - das DOM-Element, welches beschrieben wird
     * @constructor
     */

    var v3sConnectableElement = function (id) {
        this.id;
        this.status = this.STATUS.SILENT_CORRECT;
        this.hasCorrectAnswer = function () {
            return false;
        };
        this.load();
    }

    v3sConnectableElement.prototype = new v3sExerciseElement();

    return v3sConnectableElement;
}]);
